import React from "react";
import { Row, Col, Container } from "react-bootstrap";

import { useCmsHook } from "../helpers/cmsHook";

const Confirmation = () => {
  const { cmsInstance } = useCmsHook();
  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <div className="confirmation-page-box my-5">
              {cmsInstance &&
                cmsInstance.showRichText("cmsContent.confirmationPage")}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Confirmation;
